module.exports = __webpack_public_path__ + "img/avatar0.122b752b.png";